<template>
  <ConclusionStep
    status="positive"
    title="Carteira criada"
    @close="handleCloseAction"
  >
    <main class="main">
      <ContentDisplay list-length="1" content-aspect="outside">
        <template #content-block-1>
          <HeadingDisplay
            class="title-info-box"
            title="Características da Carteira"
            size="small"
          />

          <ListDisplay
            class="list-item"
            title="Nome"
            :value="router.currentRoute.query.portfolioname"
            has-divider
          />
          <ListDisplay
            class="list-item"
            title="Tipo de gestão"
            value="Manual"
          />
        </template>
      </ContentDisplay>
    </main>
    <template #button-primary>
      <ButtonPrimary label="Investir" size="large" @click="handleNextClick" />
    </template>
  </ConclusionStep>
</template>
<script setup lang="ts">
import {
  HeadingDisplay,
  ContentDisplay,
  ButtonPrimary,
  ListDisplay,
  ConclusionStep
} from '@warrenbrasil/nebraska-web';
import { useRouter } from 'vue-router/composables';
import {
  trackCreatedSuccessClose,
  trackCreatedSuccessInvest
} from './track-events';

const router = useRouter();

function handleNextClick() {
  trackCreatedSuccessInvest();
  router.push({
    name: 'wealthProductTransaction',
    params: { id: router.currentRoute.params.id }
  });
}

function handleCloseAction() {
  trackCreatedSuccessClose();
  router.push({ name: 'wealth' });
}
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  max-width: 592px;

  .title-info-box {
    margin-bottom: @size-spacing-x500;
  }

  .list-item {
    margin-bottom: @size-spacing-x350;
  }
}

.content-display {
  width: 100%;
  padding-bottom: @size-spacing-x500;
}

.to-sm({
  :deep(.flow-conclusion__container) {
    padding: 0 @size-spacing-x400;
  }

  :deep(.content-display__outside) {
    margin: @size-spacing-x500 @size-spacing-x600;
  }

  .content-display {
    padding-bottom: 0;
  }
});
</style>
